import { NgModule } from '@angular/core';
import { LibContainerComponent } from './container.component';
import { CommonModule } from '@angular/common';



@NgModule({
  declarations: [
    LibContainerComponent
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    LibContainerComponent
  ]
})
export class LibContainerModule { }
